import React from "react";
import axios from "axios";
import { conf } from "../../../conf2";
import Table from "./components/Table/Table";

export default class TopAccountsList extends React.Component {
  state = {
    accounts: [],
  };

  componentDidMount() {
    axios.get(conf.topAccounts).then((res) => {
      const accounts = res.data;
      this.setState({ accounts });
    });
  }

  render() {
    if (this.state.accounts.length && this.state.accounts.length > 0) {
      return (
        <Table
          data={{
            headers: ["Id", "Balance"],
            items: this.state.accounts,
          }}
        />
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Stats/Lists/TopAccounts.js